var $sortLabels = null;

$(document).ready(function() {
	
	$sortLabels = $(".sortselect");
	
	transferSearchFilter.init();
	transferSortFilter.init();
});


var transferSearchFilter = function() {

	this.init = function (){
		
		$("input[type='checkbox'][name='filterType']").click(function() {
			applyFilter();
			$('#resetFilterType').show();
		});
		
		$("input[type='checkbox'][name='filterCategory']").click(function() {
			applyFilter();
			$('#resetFilterCategory').show();
		});
		
		if(Transfer.resultTable != null){
			
			var minPrice = $(Transfer.resultTable.first()).attr("data-minprice");
			var maxPrice = $(Transfer.resultTable.last()).attr("data-minprice");
			var minSliderValue = parseInt(minPrice / 10, 10) * 10;
			var maxSliderValue = parseInt(maxPrice / 10, 10) * 10 + 10;
			
			//PRICE SLIDER #1
			$("#slider-range1").slider({
				range: true,
				min: minSliderValue,
				max: maxSliderValue,
				values: [ minSliderValue, maxSliderValue ],
				step: 10,
				slide: function(event, ui) {
					$("#filterByPrice").val(ui.values[0] + " " + $.cookie('currency') + " - " + ui.values[1] + " " + $.cookie('currency'));
				}
			});
			
			$("#filterByPrice").val($("#slider-range1").slider("values", 0) + " " + $.cookie('currency') + " - " + $("#slider-range1").slider("values", 1) + " " + $.cookie('currency'));
			
			$("#slider-range1").slider({change: function(event, ui) {
				applyFilter();
				$('#resetFilterPrice').show();
			}});
		}

	}
	
	$("#resetFilterCategory").click(function() {
		$('.filter-category').prop("checked", true);
		$(this).hide();
		applyFilter();
	});
	
	$("#resetFilterType").click(function() {
		$('.filter-type').prop("checked", true);
		$(this).hide();
		applyFilter();
	});

	this.applyFilter = function() {
		var filter = getFilter();
		Transfer.resultTable.each(function(index, item){
			var show = isMatchesFilter(item, filter);
			if(show){
				$( item ).show();
			    $( item ).attr("data-visible","true");
			}
			else{
				$( item ).hide();
			    $( item ).attr("data-visible","false");
			}    
		});
		$( document ).trigger( "transfer_filter_event");
	}
	
	function _fnEscapeRegex ( sVal ) {
		var letters = { "İ": "[İi]", "I": "[Iı]", "Ş": "[Şş]", "Ğ": "[Ğğ]", "Ü": "[Üü]", "Ö": "[Öö]", "Ç": "[Çç]", "i": "[İi]", "ı": "[Iı]", "ş": "[Şş]", "ğ": "[Ğğ]", "ü": "[Üü]", "ö": "[Öö]", "ç": "[Çç]" };
		return sVal.replace(/(([İIŞĞÜÇÖiışğüçö]))/g, function (letter) { return letters[letter]; });
	}

	var isMatchesFilter = function(item, filter){
	
		if($(item).attr("data-type") in filter.types && !filter.types[$(item).attr("data-type")]){
			return false;
		}

		if($(item).attr("data-category") in filter.categories && !filter.categories[$(item).attr("data-category")]){
			return false;
		}
		
		if(filter.minprice > $(item).attr("data-minprice") || filter.maxprice < $(item).attr("data-minprice"))
			return false;

	
		return true;
	}
	
	this.resetFilter = function(filterName) {
		
	}
	
	var $types = $(".filter-type");
	var $categories = $(".filter-category");
	
	var getFilter = function(){
		
		var types = {}
		$types.each(function(index, item){
			types[item.value] = $(item).prop("checked");
		});
		
		var categories = {}
		$categories.each(function(index, item){
			categories[item.value] = $(item).prop("checked");
		});
		
		return {
			minprice : $("#slider-range1").slider("values", 0),
			maxprice :  $("#slider-range1").slider("values", 1),
			types : types,
			categories : categories
		}
	}
	
	return {
		init : init,
		applyFilter : applyFilter,
		resetFilter : resetFilter
	}
	
}();


var transferSortFilter = function() {

	this.init = function (){
		
		$sortLabels.on('change', function(event){
	
			$("div.select-style.active").not(this)
				.removeClass("active").removeClass("desc");
			
			$("select.sortselect").not(this).val(0);
			
			var $this = $(this);
			var $option = $this.find(":selected");
			var attribute = $option.attr("data-filter-attribute");
			var direction = $option.attr("data-filter-direction");
			
			$this.parent().addClass("active");
			if (direction == 'desc') {
				$this.parent().addClass("dec");
			}else{
				$this.parent().removeClass("dec");
			}
			var valueType = $option.attr("data-filter-value-type");
			var transferSortFunction = function(a, b) {
				var result;
				var valueA = $(a).attr(attribute);
				var valueB = $(b).attr(attribute);

				if (valueType == 'numeric') {
					valueA = parseFloat(valueA);
					valueB = parseFloat(valueB);
				}
				result = (valueA < valueB) ? -1 : (valueA > valueB) ? 1 : 0;
				if (direction == 'desc') {
					result *= -1;
				}
				return result;
			};

			Transfer.resultTable.sort(transferSortFunction).appendTo("#transferResultTable");

			$( document ).trigger( "transfer_filter_event");

		});
		
		// SORT BY RECOMENDED
		var sortbyRecomended = function(a, b) {
			var result;
			var valueA = $(a).attr('recomended') == 'true' ? 0 : 1;
			var valueB = $(b).attr('recomended') == 'true' ? 0 : 1;

			result = (valueA < valueB) ? -1 : (valueA > valueB) ? 1 : 0;

			return result;
		};
		Transfer.resultTable.sort(sortbyRecomended).appendTo("#transferResultTable");
		
	}

	return {
		init : init
	}
	
}();
